let columnsJson = [
    {prop:'task_id',filterMultiple:true,label:'任务ID',fixed:'left',width:'80',resizable: true},
    {prop:'order_part_id',filterMultiple:true,label:'后台订单ID',fixed:'left',width:'80',resizable: true},
    {prop:'month',filterMultiple:false,label:'所属月份',width:'80',resizable: true},
    {prop:'cost_type',filterMultiple:false,label:'订单类型',width:'100',resizable: true},
    {prop:'amount',filterMultiple:false,label:'消耗金额',width:'100',resizable: true},
    {prop:'if_public',filterMultiple:false,label:'收否对公',width:'100',resizable: true},
    {prop:'internet_celebrity_name',filterMultiple:false,label:'网红名称',width:'100',resizable: true},
    {prop:'internet_celebrity_name',filterMultiple:false,label:'网红ID',width:'100',resizable: true},
]
export default columnsJson


// WEBPACK FOOTER //
// ./src/components/Order/json/incomplete.js